import { fetchGetMsgEntrance } from "@/apis/message/message.api";
import JDILogin from "@/app/login/index.login";
import callAfterLogin from "@/app/login/utils/callAfterLogin";
import MessageIcon from "@/assets/icons/message-icon.svg";
import ZECustomerService from '@/components/customerService';
import { EXPCONFIG_FAST } from "@/constants/point";
import { useTranslation } from "@/i18n/client";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25630";
import cn from "clsx";
import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { Props } from "../index";
import floatingToolBtnStyle from "./FloatingToolBarBtn.module.scss";
import(/* webpackPrefetch: true */ "@/components/message");
const Message = lazy(() => import("@/components/message"));

const JDIMessageBtn = ({ open, onOpen }: Props) => {
  const maxMessageCount = 100;
  const { t } = useTranslation();
  const [totalNum, setTotalNum] = useState<number>(0);
  const [showPoint, setShowPoint] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const zeRef = useRef<any>(null);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setIsOpen(open as boolean);
  }, [open]);

  const init = async () => {
    const { isLoggedIn } = await JDILogin.getInstance().getUserInfo();
    if (isLoggedIn) {
      let serviceNum = 0;
      let messageNum = 0;
      let initService = false;
      let initMessage = false;
      let isRedPoint = false;
      if (window && (window as any).zE) {
        (window as any).zE("messenger:on", "unreadMessages", function (count: number) {
          serviceNum = count;
          initService = true;
          if (initMessage) {
            setShowPoint(!serviceNum && isRedPoint);
            setTotalNum(serviceNum + messageNum);
          }
        });
      }
      const res = await fetchGetMsgEntrance();
      initMessage = true;
      if (res && res.data && res.code === "200") {
        isRedPoint = res.data.isRedPoint;
        messageNum = res.data.unReadedCount;
      }
      if (initService) {
        setShowPoint(!serviceNum && isRedPoint);
        setTotalNum(serviceNum + messageNum);
      }
    }
  };

  const handleMessageBtn = () => {
    callAfterLogin(() => {
      onOpen && onOpen();
      setIsOpen(true);
    });
    sendClickTrack.Sidebar_Message_Click();
  };

  return (
    <div exptag={"exp|" + EXPOSURE_RECORD.Sidebar_Message_Expo} data-exptag-config={EXPCONFIG_FAST}>
      <button className={cn(floatingToolBtnStyle.floatingBtn, floatingToolBtnStyle.heightNormal)} onClick={handleMessageBtn}>
        <div className={floatingToolBtnStyle.iconTextWrap}>
          <MessageIcon className={floatingToolBtnStyle.hoverIcon} />
          {totalNum > 0 ? (
            <div className={floatingToolBtnStyle.messageIcon}>
              <span>{totalNum < maxMessageCount ? totalNum : "99+"}</span>
            </div>
          ) : (
            showPoint && <span className={floatingToolBtnStyle.point} />
          )}
        </div>
        <div className={floatingToolBtnStyle.btnText}>{t("floatingToolbar.message")}</div>
      </button>
      {
        isOpen && (
          <Suspense fallback={null}>
            <Message
              open={isOpen}
              onClose={() => {
                setIsOpen(false);
              }}
              onUpdate={(num: number, show: boolean) => {
                setTotalNum(num);
                setShowPoint(show);
              }}
            />
          </Suspense>
        )}
       {/* 客服组件引入 */}
       <ZECustomerService ref={zeRef} />
    </div>
  );
};

export default JDIMessageBtn;
